var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableCell, TableRow } from '../../common';
import { ExpandableRowLabel } from '../../common/tableHierarchy';
import { FirstCell, STICKIES } from '../annualTable';
import { HIERARCHY_LEVEL, NEST_LEVEL } from '../constants';
import { getHighlightBorder } from './utils';
export var LobHeaderRow = function (_a) {
  var displayName = _a.displayName,
    data = _a.data,
    chunkSize = _a.chunkSize,
    backgroundColor = _a.backgroundColor,
    firstCellColor = _a.firstCellColor,
    expanded = _a.expanded,
    onToggle = _a.onToggle,
    _b = _a.nestLevel,
    nestLevel = _b === void 0 ? HIERARCHY_LEVEL.lob : _b;
  return _jsxs(TableRow, {
    children: [_jsx(FirstCell, __assign({
      "aria-label": NEST_LEVEL[nestLevel],
      stickySizes: STICKIES,
      color: firstCellColor !== null && firstCellColor !== void 0 ? firstCellColor : backgroundColor
    }, {
      children: _jsx(ExpandableRowLabel, __assign({
        expanded: expanded,
        onToggle: onToggle
      }, {
        children: displayName
      }))
    })), data.map(function (_, index, arr) {
      return _jsx(TableCell, {
        colSpan: 2,
        color: backgroundColor,
        highlightBorder: getHighlightBorder(index, arr.length, chunkSize)
      }, "lob-header-".concat(displayName, "-").concat(index));
    })]
  });
};